/** How a participant left the platform tour: walked every stop, or chose to stop it. */
export enum PlatformTourOutcome {
  FINISHED = 'finished',
  SKIPPED = 'skipped'
}
